import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { MvaStoreRS } from "../../stores/mvas/MvaStoreRS";
import { MDBCol, MDBRow } from "mdbreact";
import { format_value_mva } from "../../utils";
import { IMvaRS } from "../../model";

interface MvaRsDialogDuplicarProps {
  mva: IMvaRS;
  onClose: () => void;
}

interface MvaRsDialogDuplicarState {
}

@observer
export class MvaRsDialogDuplicar
  extends React.Component<MvaRsDialogDuplicarProps, MvaRsDialogDuplicarState> {
  obs = observable({
    mva: {} as IMvaRS,
    open_select_segments: false as boolean
  })

  async componentDidMount() {

    this.obs.mva = { ...this.props.mva }

  }

  handleSaveDuplica = async (mva) => {

    mva.mva_positiva = format_value_mva(mva.mva_positiva)
    mva.mva_neutra = format_value_mva(mva.mva_neutra)
    mva.mva_negativa = format_value_mva(mva.mva_negativa)
    mva.mva_ajustada_4 = format_value_mva(mva.mva_ajustada_4)
    mva.mva_ajustada_7 = format_value_mva(mva.mva_ajustada_7)
    mva.mva_ajustada_12 = format_value_mva(mva.mva_ajustada_12)
    mva.mva_ajustada = format_value_mva(mva.mva_ajustada)
    mva.mva = format_value_mva(mva.mva)
    mva.aliquota_interna = format_value_mva(mva.aliquota_interna).replace(/\,/g, ".")
    mva.seg_auto_pecas = mva.seg_auto_pecas,
    mva.seg_vet_pet = mva.seg_vet_pet,
    mva.seg_refrigerantes = mva.seg_refrigerantes,
    mva.seg_agua_out = mva.seg_agua_out,
    mva.seg_lamp_reatores = mva.seg_lamp_reatores,
    mva.seg_mat_limpeza = mva.seg_mat_limpeza,
    mva.seg_pneumaticos_prot = mva.seg_pneumaticos_prot,
    mva.seg_alimenticios = mva.seg_alimenticios,
    mva.seg_perf_cosm = mva.seg_perf_cosm,
    mva.seg_eletro = mva.seg_eletro,
    mva.seg_racoes = mva.seg_racoes,
    mva.seg_sorvetes_fab = mva.seg_sorvetes_fab,
    mva.seg_tintas = mva.seg_tintas,
    mva.seg_mat_construcao = mva.seg_mat_construcao,
    mva.seg_veiculos_automotores = mva.seg_veiculos_automotores,
    mva.seg_veiculos_novos = mva.seg_veiculos_novos,
    mva.seg_medicamentos_humano = mva.seg_medicamentos_humano

    delete mva._id
    delete mva.id

    let res = await MvaStoreRS.doSaveDuplicaMva(mva);

    if (res) {

      this.props.onClose()

    }

  };

  render() {

    if (!this.obs.mva) {
      return null;
    }

    return (
      <>
        <Dialog
          isOpen={true}
          onClose={this.props.onClose}
          style={{ width: 600, height: 400 }}
        >
          <div className={Classes.DIALOG_HEADER}>
            <h2 className="title-no-bottom">Duplicar MVA</h2>
          </div>

          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol>
                <FormGroup label="MVA Positiva">
                  <InputGroup value={this.obs.mva.mva_positiva} onChange={(e) => this.obs.mva.mva_positiva = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
              <MDBCol>
                <FormGroup label="MVA Neutra">
                  <InputGroup value={this.obs.mva.mva_neutra} onChange={(e) => this.obs.mva.mva_neutra = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
              <MDBCol>
                <FormGroup label="MVA Negativa">
                  <InputGroup value={this.obs.mva.mva_negativa} onChange={(e) => this.obs.mva.mva_negativa = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol>
                <FormGroup label="MVA Ajustada 4%">
                  <InputGroup value={this.obs.mva.mva_ajustada_4} onChange={(e) => this.obs.mva.mva_ajustada_4 = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
              <MDBCol>
                <FormGroup label="MVA Ajustada 7%">
                  <InputGroup value={this.obs.mva.mva_ajustada_7} onChange={(e) => this.obs.mva.mva_ajustada_7 = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
              <MDBCol>
                <FormGroup label="MVA Ajustada 12%">
                  <InputGroup value={this.obs.mva.mva_ajustada_12} onChange={(e) => this.obs.mva.mva_ajustada_12 = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol>
                <FormGroup label="MVA Ajustada">
                  <InputGroup value={this.obs.mva.mva_ajustada} onChange={(e) => this.obs.mva.mva_ajustada = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
              <MDBCol>
                <FormGroup label="MVA">
                  <InputGroup value={this.obs.mva.mva} onChange={(e) => this.obs.mva.mva = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
              <MDBCol>
                <FormGroup label="Aliquota Interna">
                  <InputGroup value={this.obs.mva.aliquota_interna} onChange={(e) => this.obs.mva.aliquota_interna = e.target.value} placeholder="Exemplo: 54,8950" />
                </FormGroup>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol>
                <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_segments = true}>{"Selecione os Segmentos"}</b></span>
              </MDBCol>
            </MDBRow>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={this.props.onClose} />
              <Button text="Duplicar" intent="primary" onClick={() => this.handleSaveDuplica(this.obs.mva)} />
            </div>
          </div>
        </Dialog>
      
        <Dialog
          isOpen={this.obs.open_select_segments}
          onClose={() => this.obs.open_select_segments = false}
          style={{ width: 600, height: 400 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <FormGroup
              label="Selecione os segmentos:"
              labelFor="segmentos"
              >
              <div style ={{overflow: "auto", maxHeight: 400}}>
                <Checkbox
                  label={"Autopeças"}
                  checked={this.obs.mva.seg_auto_pecas}
                  onChange={(event: any) => this.obs.mva.seg_auto_pecas = event.target.checked}
                />
                <Checkbox
                  label={"Veterinário/pet"}
                  checked={this.obs.mva.seg_vet_pet}
                  onChange={(event: any) => this.obs.mva.seg_vet_pet = event.target.checked}
                />
                <Checkbox
                  label={"Refrigerantes"}
                  checked={this.obs.mva.seg_refrigerantes}
                  onChange={(event: any) => this.obs.mva.seg_refrigerantes = event.target.checked}
                />
                <Checkbox
                  label={"Aguas e outras bebidas"}
                  checked={this.obs.mva.seg_agua_out}
                  onChange={(event: any) => this.obs.mva.seg_agua_out = event.target.checked}
                />
                <Checkbox
                  label={"Lâmpadas, reatores e starter"}
                  checked={this.obs.mva.seg_lamp_reatores}
                  onChange={(event: any) => this.obs.mva.seg_lamp_reatores = event.target.checked}
                />
                <Checkbox
                  label={"Materiais de limpeza"}
                  checked={this.obs.mva.seg_mat_limpeza}
                  onChange={(event: any) => this.obs.mva.seg_mat_limpeza = event.target.checked}
                />
                <Checkbox
                  label={"Pneumáticos, câmaras de ar e protetores de borracha"}
                  checked={this.obs.mva.seg_pneumaticos_prot}
                  onChange={(event: any) => this.obs.mva.seg_pneumaticos_prot = event.target.checked}
                />
                <Checkbox
                  label={"Produtos alimentícios"}
                  checked={this.obs.mva.seg_alimenticios}
                  onChange={(event: any) => this.obs.mva.seg_alimenticios = event.target.checked}
                />
                <Checkbox
                  label={"Produtos de perfumaria e de higiene pessoal e cosméticos"}
                  checked={this.obs.mva.seg_perf_cosm}
                  onChange={(event: any) => this.obs.mva.seg_perf_cosm = event.target.checked}
                />
                <Checkbox
                  label={"Produtos eletrônicos, eletroeletrônicos e eletrodomésticos"}
                  checked={this.obs.mva.seg_eletro}
                  onChange={(event: any) => this.obs.mva.seg_eletro = event.target.checked}
                />
                <Checkbox
                  label={"Rações para animais domésticos"}
                  checked={this.obs.mva.seg_racoes}
                  onChange={(event: any) => this.obs.mva.seg_racoes = event.target.checked}
                />
                <Checkbox
                  label={"Sorvetes e preparados para fabricação de sorvetes em máquinas"}
                  checked={this.obs.mva.seg_sorvetes_fab}
                  onChange={(event: any) => this.obs.mva.seg_sorvetes_fab = event.target.checked}
                />
                <Checkbox
                  label={"Tintas e vernizes"}
                  checked={this.obs.mva.seg_tintas}
                  onChange={(event: any) => this.obs.mva.seg_tintas = event.target.checked}
                />
                <Checkbox
                  label={"Material de construção"}
                  checked={this.obs.mva.seg_mat_construcao}
                  onChange={(event: any) => this.obs.mva.seg_mat_construcao = event.target.checked}
                />
                <Checkbox
                  label={"Veículos automotores novos"}
                  checked={this.obs.mva.seg_veiculos_automotores}
                  onChange={(event: any) => this.obs.mva.seg_veiculos_automotores = event.target.checked}
                />
                <Checkbox
                  label={"Veículos novos de duas e três rodas motorizados"}
                  checked={this.obs.mva.seg_veiculos_novos}
                  onChange={(event: any) => this.obs.mva.seg_veiculos_novos = event.target.checked}
                />
                <Checkbox
                  label={"Medicamentos de uso humano e outros produtos farmacêuticos"}
                  checked={this.obs.mva.seg_medicamentos_humano}
                  onChange={(event: any) => this.obs.mva.seg_medicamentos_humano = event.target.checked}
                />
              </div>
            </FormGroup>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.obs.open_select_segments = false} />
              <Button
                text="Salvar"
                intent="primary"
                onClick={() => {
                  this.obs.open_select_segments = false;
                }}
              />
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}
